(function () {
  var container = document.querySelector('.globo-formbuilder');
  if (!container) return;

  var published = false;

  function publishContactFormSubmitted() {
    if (published) return;
    published = true;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('contact_form_submitted', {});
    }
  }

  function checkSuccess() {
    var successEl = container.querySelector('.message.success');
    if (successEl && successEl.style.display === 'block') {
      publishContactFormSubmitted();
      observer.disconnect();
    }
  }

  var observer = new MutationObserver(checkSuccess);
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['style'],
    childList: true,
    subtree: true
  });

  checkSuccess();
})();
